import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Company from "@/pages/Company";
import Divisions from "@/pages/Divisions";
import PetroleumEnergy from "@/pages/PetroleumEnergy";
import PreciousMetals from "@/pages/PreciousMetals";
import Strategic from "@/pages/Strategic";
import Leadership from "@/pages/Leadership";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import { PageContentProvider } from "@/context/PageContentContext";

import AdminLayout from "@/admin/AdminLayout";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLogin from "@/admin/Login";
import AdminChangePassword from "@/admin/ChangePassword";
import SetupPassword from "@/admin/SetupPassword";
import Dashboard from "@/admin/Dashboard";
import EnquiriesList from "@/admin/EnquiriesList";
import EnquiryDetail from "@/admin/EnquiryDetail";
import ContentEditor from "@/admin/ContentEditor";
import IntegrationStatus from "@/admin/IntegrationStatus";
import Evidence from "@/admin/Evidence";
import Help from "@/admin/Help";
import Settings from "@/admin/Settings";
import Users from "@/admin/Users";

import "@/App.css";

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AdminAuthProvider>
            <Routes>
              {/* Public routes */}
              <Route
                element={
                  <PageContentProvider>
                    <Layout />
                  </PageContentProvider>
                }
              >
                <Route path="/" element={<Home />} />
                <Route path="/company" element={<Company />} />
                <Route path="/divisions" element={<Divisions />} />
                <Route path="/divisions/petroleum-energy" element={<PetroleumEnergy />} />
                <Route path="/divisions/precious-metals" element={<PreciousMetals />} />
                <Route path="/strategic-relationships" element={<Strategic />} />
                <Route path="/leadership" element={<Leadership />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
              </Route>

              {/* Admin routes — bare (no public header/footer) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/setup" element={<SetupPassword />} />
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/change-password" element={<AdminChangePassword />} />
                <Route path="/admin/enquiries" element={<EnquiriesList />} />
                <Route path="/admin/enquiries/:id" element={<EnquiryDetail />} />
                <Route path="/admin/content" element={<ContentEditor />} />
                <Route path="/admin/integrations" element={<IntegrationStatus />} />
                <Route path="/admin/evidence" element={<Evidence />} />
                <Route path="/admin/help" element={<Help />} />
                <Route path="/admin/settings" element={<Settings />} />
                <Route path="/admin/settings/users" element={<Users />} />
              </Route>

              <Route path="*" element={<Layout />}>
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </AdminAuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
